import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/console/$orgId/component-showcase')({
    staticData: {
        breadcrumb: {
            title: 'Component Showcase',
            inactive: true,
        },
        featureFlag: 'enable-debug-info',
    },
    component: Outlet,
});
